export default "__VITE_ASSET__Cd7FkMM7__"